import { action } from 'typesafe-actions'
import { GuideTypes } from './types'

export const changeShowInformation = (payload: boolean) =>
  action(GuideTypes.CHANGE_INFORMATION, payload)
